import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { assetUrl } from "@/lib/api";

export const Testimonials = ({ content }) => {
  return (
    <section
      id="testimoni"
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-gradient-to-b from-sky-50 to-background"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            Profil Testimoni
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Apa Kata Mereka?</h2>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">
            Cerita nyata dari siswa dan orang tua yang telah merasakan manfaat belajar bersama kami.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {content.testimonials.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`testimonial-card-${i}`}
              className={`relative p-8 rounded-3xl bg-white border border-slate-100 shadow-xl shadow-slate-200/50 hover:-translate-y-2 transition-all duration-300 ${
                i % 2 === 1 ? "md:mt-8" : ""
              }`}
            >
              <Quote className="w-10 h-10 text-sky-200 mb-4" />
              <div className="flex mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-slate-600 leading-relaxed mb-6">"{t.text}"</p>
              <div className="flex items-center gap-3 pt-5 border-t border-slate-100">
                {t.image ? (
                  <img
                    src={assetUrl(t.image)}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover ring-2 ring-sky-100"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center text-sky-600 font-bold">
                    {t.name?.charAt(0)}
                  </div>
                )}
                <div>
                  <div className="font-bold text-slate-900">{t.name}</div>
                  <div className="text-xs text-sky-600 font-medium">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
